import { Drawer, Table, Tag, Icon } from "antd";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";

class TaskDetails extends React.Component {
    state = {
        visible: true,
        loading: false
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 300);
    }

    render() {
        const tasks = this.props.tasks || { total: 0, data: [] };
        const { total, data } = tasks;

        const column = [
            {
                title: "Task Details",
                key: "task",
                width: "35%",
                render: (text, record) => (
                    <div style={{ padding: '5px 0' }}>
                        <div style={{ fontWeight: 600, color: "#1a3353", fontSize: '14px', marginBottom: '4px' }}>
                            {record.taskTitle}
                        </div>
                        <div style={{ fontSize: '12px', color: "#778ca2", lineHeight: '1.4' }}>
                            {record.description || "No description provided"}
                        </div>
                    </div>
                ),
            },
            {
                title: "Assigned & Created",
                key: "assignment",
                width: "25%",
                render: (text, record) => {
                    const assignedTo = record.user_details && record.user_details.name ? record.user_details.name : "-";
                    const createdBy = record.createdByUser && record.createdByUser.name ? record.createdByUser.name : "System";

                    return (
                        <div>
                            <div style={{ marginBottom: '8px' }}>
                                <Icon type="user" style={{ marginRight: 8, color: '#4f46e5' }} />
                                <span style={{ fontWeight: 500 }}>{assignedTo}</span>
                            </div>
                            <div style={{ fontSize: '11px', color: '#999', paddingLeft: '22px' }}>
                                Created by: {createdBy}
                            </div>
                        </div>
                    );
                },
            },
            {
                title: "Schedule",
                key: "schedule",
                render: (text, record) => (
                    <div>
                        <div style={{ color: '#2d3436', fontWeight: 500 }}>
                            <Icon type="calendar" style={{ marginRight: 8, color: '#00b894' }} />
                            {record.dueDate ? moment(record.dueDate).format("DD MMM YYYY") : "No Date"}
                        </div>
                        <div style={{ fontSize: '12px', color: '#fab1a0', paddingLeft: '22px' }}>
                            <Icon type="clock-circle" style={{ marginRight: 4 }} />
                            {record.deadlineTime || "N/A"}
                        </div>
                    </div>
                ),
            },
            {
                title: "Priority",
                dataIndex: "priority",
                key: "priority",
                align: 'center',
                render: (priority) => {
                    let color = "#f6ffed";
                    let textColor = "#389e0d";
                    let borderColor = "#b7eb8f";

                    if (priority === "High") {
                        color = "#fff1f0"; textColor = "#cf1322"; borderColor = "#ffa39e";
                    } else if (priority === "Medium") {
                        color = "#fff7e6"; textColor = "#d46b08"; borderColor = "#ffd591";
                    }

                    return (
                        <Tag style={{
                            backgroundColor: color,
                            color: textColor,
                            border: `1px solid ${borderColor}`,
                            borderRadius: '4px',
                            fontWeight: 600
                        }}>
                            {priority ? priority.toUpperCase() : "NORMAL"}
                        </Tag>
                    );
                },
            },
            {
                title: "Status",
                dataIndex: "status",
                key: "status",
                align: 'right',
                render: (status) => {
                    let color = "blue";
                    if (status === "Pending") color = "orange";
                    if (status === "Completed") color = "green";
                    return (
                        <Tag color={color} style={{ borderRadius: '12px', padding: '0 12px' }}>
                            {status}
                        </Tag>
                    );
                },
            },
        ];

        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '95%' }}>
                        <span>
                            <Icon type="profile" style={{ marginRight: 10 }} />
                            Today's Tasks
                        </span>
                        <Tag
                            style={{
                                backgroundColor: '#4f46e5',
                                color: '#fff',
                                fontWeight: 700,
                                border: 'none',
                                borderRadius: '4px'
                            }}
                        >
                            {total} ACTIVE
                        </Tag>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={this.state.visible}
                width={1000}
                className="modern-drawer-task"
            >
                <Table
                    dataSource={data}
                    columns={column}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"],
                    }}
                    loading={this.state.loading}
                    rowKey={(record, index) => index}
                    style={{ background: '#fff' }}
                />
            </Drawer>
        )
    }
}

const mapDispatchToProps = dispatch => ({ dispatch });
export default connect(null, mapDispatchToProps)(TaskDetails);